window.SiteReady(($) => {

  console.log('Init Block: Exhibit');

  let $exhibits = $('.js-exhibit');
  let exhibits = [];

  if ($exhibits.length < 1) {
    return;
  }

  function onResize() {
    $exhibits = $('.js-exhibit');
    exhibits = [];

    for (let i = 0; i < $exhibits.length; i++) {
      let $exhibit = $exhibits.eq(i);
      let offset = $exhibit.offset();
      let height = $exhibit.outerHeight(true);
      let $items = $exhibit.find('.js-exhibit_item');
      let exhibit = {
        $exhibit: $exhibit,
        $items: $items,
        top: offset.top,
        bottom: offset.top + height,
        items: []
      };

      for (let ii = 0; ii < $items.length; ii++) {
        let $item = $items.eq(ii);
        let height = $item.outerHeight(true);
        let offset = $item.offset();

        exhibit.items.push({
          $el: $item,
          height: height,
          top: offset.top,
          center: offset.top + (height / 2),
        });
      }

      exhibits.push(exhibit);
    }

    onScroll();
  }

  function onScroll() {
    let height = $(window).height();
    let scrollTop = $(window).scrollTop();
    let scrollBottom = scrollTop + height;
    let scrollCenter = scrollTop + (height * 0.3);

    $.each(exhibits, function(i, exhibit) {
      if (exhibit.items.length > 0) {
        let delta = Infinity;
        let $active = exhibit.items[0].$el;

        if (scrollTop + height > exhibit.top && scrollBottom < exhibit.bottom + height) {
          $.each(exhibit.items, function(ii, item) {
            let d = Math.abs(scrollCenter - item.center);

            if (d < delta) {
              index = ii;
              $active = item.$el;
              delta = d;
            }
          });

          exhibit.$items.not($active).removeClass('active');
          $active.addClass('active');
        }
      }
    });
  }

  function onRAF() {
    onScroll();

    window.requestAnimationFrame(onRAF);
  }

  //

  $(window).on('resize.exhibit', onResize).on('load.exhibit', onResize);

  onResize();

  window.requestAnimationFrame(onRAF);


 });
